export default __webpack_public_path__ + "static/media/leaves.b919b4aa.png";